.cta-shop-se-content {
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.cta-shop-se-link {
  color: #42b4e6;
  cursor: pointer;
}